// Rutas del sitio web
const APP = {
    INDEX: '/',
    NOTFOUND: '*',
    ALTAS: '/AltasPendientes',
    DETALLEALTA: '/DetalleAlta',
    HISTORIAL: '/HistorialRegistros',
    DETALLEHISTORIAL: '/DetalleHistorial',
    FORMULARIOALTA: '/FormularioAlta',
    CONFIGURARREGIMENES: '/ConfigurarRegimenes',
}

export default APP;